/** Şemasız girilen adresi bağlantıya çevirir (yalnız http/https). */
export const toHref = (url: string) => (/^https?:\/\//i.test(url) ? url : `https://${url}`)

/** Ekranda gösterim: şema ve sondaki / olmadan. */
export const displayUrl = (url: string) => url.replace(/^https?:\/\//i, '').replace(/\/$/, '')

/** Alan adı + isteğe bağlı yol; şema yazılmayabilir. Yalnız http/https kabul edilir. */
export const isValidUrl = (v: string) => /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,}(:\d+)?(\/\S*)?$/i.test(v.trim())
